const devServerControlByUI = JSON.parse(localStorage.getItem('server_Data'));
export default {
  API_BASE_URI: devServerControlByUI?.serverCheckFlag === 'staging' && devServerControlByUI?.serverActivateNumber === '9100000000' ? devServerControlByUI?.serverUrl : process.env.VUE_APP_API_ROOT,
  URI_SUFFIX: {
    sessionCreate: '/v1/session/create',
    customerLogin: '/v2/customer/login',
    customerOtp: '/v2/customer/otp',
    customerLogout: '/v1/customer/logout',
    customerResendOtp: '/v2/customer/resend-otp',
    customerServiceabilityCheck: '/v1/customer/location/serviceability-check',
    customerFaceVerification: '/v1/customer/face-verification',
    customer: '/v1/customer/',
    consentStatus: '/v1/consent-status',
    application: '/v1/application/',
    v2Application: '/v2/application/',
    v3Application: '/v3/application/',
    v4Application: '/v4/application/',
    applicationMarketplace: '/v1/application/marketplace',
    webflow: '/v1/webflow',
    opsTeamMember: '/v1/ops/team-member',
    webflowCustomerDetails: '/v1/webflow/customer-details',
    webflowMembershipDetails: '/v1/webflow/membership-details',
    webflowShortReferral: '/v1/webflow/short-referral',
    v2WebflowShortReferral: '/v2/webflow/short-referral',
    v3WebflowShortReferral: '/v3/webflow/short-referral',
    webflowApproval: '/v1/webflow/approval',
    home: '/v1/home',
    applicationState: '/v1/application/state',
    gstin: '/gstin/v1/',
    task: '/v1/task/',
    creditloan: '/v1/creditloan/',
    v2Creditloan: '/v2/creditloan/',
    dualDocument: '/v1/dual-document/',
    dualDocumentDocuments: '/v1/dual-document/documents',
    applicationVernacularDeclaration: '/v1/application/vernacular-declaration',
    applicationVaDetails: '/v1/application/va-details',
    applicationNbfcSignedDocument: '/v1/application/nbfc-singed-document',
    v2Emandate: '/v2/emandate/',
    v5Emandate: '/v5/emandate/',
    v6Emandate: '/v6/emandate/',
    emandateRegister: '/v1/emandate/register/',
    applicationCityAndState: '/v1/application/city-and-state/',
    applicationOwnershipType: '/v1/application/ownership-type',
    applicationBusinessTypeAndCategory: '/v1/application/business-type-and-category',
    applicationAccountType: '/v1/application/account-type',
    applicationStores: '/v1/application/stores',
    signzyDigilockerUrl: '/v1/signzy/digilocker-url',
    signzy: '/v1/signzy/',
    digiLockerSubmitDetails: '/v1/digiLocker/submit-details',
    applicationEducationQualifications: '/v1/application/educational-qualification',
    marketplaceLogoUrl: '/v1/marketplace/logo-url',
    card: '/v1/card',
    perfios: '/v1/perfios/',
    cardSetPin: '/v1/card/set-pin',
    cardLockUnlock: '/v1/card/lock-unlock',
    cardChannelLimit: '/v1/card/channel-limit',
    cardChannelStatus: '/v1/card/channel-status',
    referralStart: '/v1/referral/start',
    customerSupport: '/v1/customer/support/',
    customerTransactionPaymentMethod: '/v1/customer/transaction/payment-method',
    repaymentApplication: '/v1/repayment/application/',
    applicationCreditScore: '/v1/application/credit-score/',
    offers: '/v1/offers',
    onboardingMarketplace: '/v1/on-boarding-marketplace',
    supplierTransactionDetails: '/v2/customer/transaction-details/',
    customerBlockedTransactions: '/v1/customer/blocked-transactions/',
    customerPaymentLink: '/v1/customer/payment/link',
    applicationMerchantOnboardingLink: '/v1/application/merchant/onboarding-link',
    customerPhoneBySession: '/v1/customer/phone-by-session',
    customerReferralLink: '/v1/customer/referral-link',
    creditloanApprovedAmount: '/v1/creditloan/approved-amount/',
    rewards: '/v1/rewards',
    homeFlags: '/v1/home/flags',
    digiLockerKarzaOtp: '/v1/digilocker/karza/otp',
    digiLockerKarzaVerifyOtp: '/v1/digilocker/karza/verify-otp',
    v2digiLockerKarzaVerifyOtp: '/v2/digilocker/karza/verify-otp',
    signdesk: '/v1/emandate/signdesk/request',
    customerBankName: '/v2/customer/banks',
    customerBranchNameIfsc: '/v2/customer/ifsc',
    generateStatement: '/v2/customer/generate-statement',
    initiateTransaction: '/v2/repayment/initiate-transaction',
    otherBanks: '/v1/repayment/other-banks',
    processTransaction: '/v2/repayment/process-transaction',
    initPaytmSubscription: '/v1/emandate/init-paytm-subscription',
    registerPaytmMandate: '/v1/emandate/register-paytm-mandate',
    paymentDetails: '/v1/customer/transaction',
    createConsent: '/v2/onemoney/create-consent',
    // gPay
    averageValue: '/v2/customer/gpay/average-value',
    referralStartForGPay: '/v1/referral/gpay/start',
    gPayFetchDetails: '/v2/customer/gpay/fetchDetails',
    gPayShortReferral: '/v3/webflow/gpay/short-referral',
    gPaySuppliers: '/v1/gpay/suppliers',
    transactionSupplier: '/v1/customer/transaction-supplier/',
    gPayProcessPayment: '/v1/customer/process-payment',
    gPayResendPaymentOtp: '/v1/customer/resend-payment-otp',
    gPayVerifyPaymentOtp: '/v1/customer/verify-payment-otp',
    gPayIsUserBlocked: '/v1/customer/is-user-blocked',
    gPayPendingSupplier: '/v1/customer/pending-supplier',
    gPayV2OnboardingLink: '/v2/application/merchant/onboarding-link',
    aadhar: '/v1/aadhar',
    vkyc: '/v1/vkyc',
    glib: '/v1/glib',
    digitap: '/v1/digitap',
    bankStatement: '/v1/bank-statement',
    languageList: '/v1/language',
    onboardingAgreement: '/v1/onboarding-agreement'
  },
  getEndpoint(identifier, id = undefined, id2 = undefined) {
    let URI_SUFFIX;
    switch (identifier) {
      case 'sessionCreate':
        URI_SUFFIX = this.URI_SUFFIX.sessionCreate;
        break;
      case 'customerLogin':
        URI_SUFFIX = this.URI_SUFFIX.customerLogin;
        break;
      case 'customerOtp':
        URI_SUFFIX = this.URI_SUFFIX.customerOtp;
        break;
      case 'customerLogout':
        URI_SUFFIX = this.URI_SUFFIX.customerLogout;
        break;
      case 'customerResendOtp':
        URI_SUFFIX = this.URI_SUFFIX.customerResendOtp;
        break;
      case 'customerServiceabilityCheck':
        URI_SUFFIX = this.URI_SUFFIX.customerServiceabilityCheck;
        break;
      case 'customerFaceVerification':
        URI_SUFFIX = this.URI_SUFFIX.customerFaceVerification;
        break;
      case 'customerReferralCode':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/referral-code`;
        break;
      case 'consentStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.consentStatus}`;
        break;
      case 'customerNbfcInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/nbfc-info`;
        break;
      case 'customerTransactionDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/transaction-details`;
        break;
      case 'customerLoyaltyPoint':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/loyalty-point`;
        break;
      case 'application':
        URI_SUFFIX = this.URI_SUFFIX.application;
        break;
      case 'applicationState':
        URI_SUFFIX = this.URI_SUFFIX.applicationState;
        break;
      case 'applicationVaDetails':
        URI_SUFFIX = this.URI_SUFFIX.applicationVaDetails;
        break;
      case 'applicationFos':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/fos`;
        break;
      case 'applicationFile':
        URI_SUFFIX = `${this.URI_SUFFIX.application}file/${id}`;
        break;
      case 'applicationTnc':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/tnc`;
        break;
      case 'applicationProfile':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/profile`;
        break;
      case 'applicationSelectNbfc':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/select-nbfc`;
        break;
      case 'applicationSummary':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/summary`;
        break;
      case 'applicationSubmit':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/submit`;
        break;
      case 'applicationBusinessOwnershipInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/business-ownership-info`;
        break;
      case 'applicationRegistrationDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/registration-details`;
        break;
      case 'applicationPan':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/pan`;
        break;
      case 'applicationAddressProof':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/address-proof`;
        break;
      case 'v3ApplicationAddressProof':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/address-proof`;
        break;
      case 'applicationAddressProof1':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/address-proof1`;
        break;
      case 'applicationPersonalId':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/personal-id`;
        break;
      case 'v2ApplicationPersonalId':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/personal-id`;
        break;
      case 'v2ApplicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/personal-info`;
        break;
      case 'v3ApplicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/personal-info`;
        break;
      case 'v4ApplicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v4Application}${id}/personal-info`;
        break;
      case 'applicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/personal-info`;
        break;
      case 'applicationQuestionnaire':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/questionnaire`;
        break;
      case 'applicationBusinessInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/business-info`;
        break;
      case 'applicationBusinessInfoV2':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/business-info`;
        break;
      case 'v3ApplicationBusinessInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/business-info`;
        break;
      case 'applicationSkipBusinessRegistrationInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/skip-business-registration-proof`;
        break;
      case 'applicationSkipMarketplaceDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/skip-marketplace-document`;
        break;
      case 'applicationMarketplaceDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/marketplace-document`;
        break;
      case 'applicationMarketplaceAccountLinkingComplete':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/marketplace-linking-complete`;
        break;
      case 'v2ApplicationSubmit':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/submit`;
        break;
      case 'applicationPostApprovalSubmission':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/post-approval-submission`;
        break;
      case 'creditLoanPostApprovalSubmission':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/post-approval-submission`;
        break;
      case 'applicationPersonalKyc':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/personal-kyc`;
        break;
      case 'applicationTransactionDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/transaction-details`;
        break;
      case 'applicationCancelledCheque':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/cancelled-cheque`;
        break;
      case 'applicationBankInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/bank-info`;
        break;
      case 'v2ApplicationBankInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/bank-info`;
        break;
      case 'applicationApplicationDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/application-document`;
        break;
      case 'applicationBusinessRegistrationProof':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/business-registration-proof`;
        break;
      case 'applicationPropertyOwnershipProof':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/property-ownership-proof`;
        break;
      case 'applicationMarketplaceLinkingComplete':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/marketplace-linking-complete`;
        break;
      case 'applicationShopPhotoInside':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/shop-photo-inside`;
        break;
      case 'applicationIdProof':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/id-proof`;
        break;
      case 'applicationSecurityCheque':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/security-cheque`;
        break;
      case 'applicationShopPhotoFront':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/shop-photo-front`;
        break;
      case 'applicationApplicantPhoto':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/applicant-photo`;
        break;
      case 'applicationIsGstVerified':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/is-gst-verified`;
        break;
      case 'applicationCityAndState':
        URI_SUFFIX = `${this.URI_SUFFIX.applicationCityAndState}${id}`;
        break;
      case 'applicationBankDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/bank-details`;
        break;
      case 'applicationContinueAnyway':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/continue-anyway`;
        break;
      case 'applicationComments':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/comments`;
        break;
      case 'applicationCreditScore':
        URI_SUFFIX = `${this.URI_SUFFIX.applicationCreditScore}${id}`;
        break;
      case 'repaymentApplicationPaymentUrl':
        URI_SUFFIX = `${this.URI_SUFFIX.repaymentApplication}${id}/payment-url`;
        break;
      case 'applicationMarketplace':
        URI_SUFFIX = this.URI_SUFFIX.applicationMarketplace;
        break;
      case 'applicationVernacularDeclaration':
        URI_SUFFIX = this.URI_SUFFIX.applicationVernacularDeclaration;
        break;
      case 'applicationNbfcSignedDocument':
        URI_SUFFIX = this.URI_SUFFIX.applicationNbfcSignedDocument;
        break;
      case 'applicationOwnershipType':
        URI_SUFFIX = this.URI_SUFFIX.applicationOwnershipType;
        break;
      case 'applicationEducationQualifications':
        URI_SUFFIX = this.URI_SUFFIX.applicationEducationQualifications;
        break;
      case 'applicationBusinessTypeAndCategory':
        URI_SUFFIX = this.URI_SUFFIX.applicationBusinessTypeAndCategory;
        break;
      case 'applicationAccountType':
        URI_SUFFIX = this.URI_SUFFIX.applicationAccountType;
        break;
      case 'applicationStores':
        URI_SUFFIX = this.URI_SUFFIX.applicationStores;
        break;
      case 'applicationVernacularDeclarationById':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/vernacular-declaration`;
        break;
      case 'applicationDocumentUploadComplete':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/document-upload-complete`;
        break;
      case 'applicationNachTemplate':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Emandate}${id}/nach-template/`;
        break;
      case 'applicationNachMandate':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Emandate}${id}/nach-mandate/`;
        break;
      case 'applicationTncDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/tnc-document`;
        break;
      case 'applicationBankStatement':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/bank-statement`;
        break;
      case 'applicationGst':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/gst`;
        break;
      case 'applicationDualName':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/dual-name`;
        break;
      case 'applicationDualDob':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/dual-dob`;
        break;
      case 'applicationResolveComment':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/resolve-comment`;
        break;
      case 'v2Emandate':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Emandate}${id}/banks/`;
        break;
      case 'v5Emandate':
        URI_SUFFIX = `${this.URI_SUFFIX.v5Emandate}${id}/banks/`;
        break;
      case 'v6Emandate':
        URI_SUFFIX = `${this.URI_SUFFIX.v6Emandate}${id}/mandate/availability`;
        break;
      case 'emandateRegister':
        URI_SUFFIX = `${this.URI_SUFFIX.emandateRegister}${id}`;
        break;
      case 'webflow':
        URI_SUFFIX = this.URI_SUFFIX.webflow;
        break;
      case 'opsTeamMember':
        URI_SUFFIX = this.URI_SUFFIX.opsTeamMember;
        break;
      case 'webflowCustomerDetails':
        URI_SUFFIX = this.URI_SUFFIX.webflowCustomerDetails;
        break;
      case 'webflowMembershipDetails':
        URI_SUFFIX = this.URI_SUFFIX.webflowMembershipDetails;
        break;
      case 'webflowShortReferral':
        URI_SUFFIX = this.URI_SUFFIX.webflowShortReferral;
        break;
      case 'v2WebflowShortReferral':
        URI_SUFFIX = this.URI_SUFFIX.v2WebflowShortReferral;
        break;
      case 'v3WebflowShortReferral':
        URI_SUFFIX = this.URI_SUFFIX.v3WebflowShortReferral;
        break;
      case 'webflowApproval':
        URI_SUFFIX = this.URI_SUFFIX.webflowApproval;
        break;
      case 'home':
        URI_SUFFIX = this.URI_SUFFIX.home;
        break;
      case 'signzyDigiLockerUrl':
        URI_SUFFIX = this.URI_SUFFIX.signzyDigilockerUrl;
        break;
      case 'signzyDigilockerStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.signzy}${id}/digilocker-status`;
        break;
      case 'signzyVideoVerification':
        URI_SUFFIX = `${this.URI_SUFFIX.signzy}${id}/video-verification`;
        break;
      case 'digiLockerSubmitDetails':
        URI_SUFFIX = this.URI_SUFFIX.digiLockerSubmitDetails;
        break;
      case 'marketplaceLogoUrl':
        URI_SUFFIX = this.URI_SUFFIX.marketplaceLogoUrl;
        break;
      case 'gstinLogin':
        URI_SUFFIX = `${this.URI_SUFFIX.gstin}${id}/login`;
        break;
      case 'gstinConsent':
        URI_SUFFIX = `${this.URI_SUFFIX.gstin}${id}/consent`;
        break;
      case 'gstinOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.gstin}${id}/otp`;
        break;
      case 'task':
        URI_SUFFIX = `${this.URI_SUFFIX.task}${id}`;
        break;
      case 'creditloanLoanDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/loan-document`;
        break;
      case 'v2CreditloanLoanDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Creditloan}${id}/loan-document`;
        break;
      case 'creditloanAmountChange':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/amount-change`;
        break;
      case 'dualDocumentDocuments':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocumentDocuments}`;
        break;
      case 'card':
        URI_SUFFIX = `${this.URI_SUFFIX.card}`;
        break;
      case 'cardSetPin':
        URI_SUFFIX = `${this.URI_SUFFIX.cardSetPin}`;
        break;
      case 'cardLockUnlock':
        URI_SUFFIX = `${this.URI_SUFFIX.cardLockUnlock}`;
        break;
      case 'cardChannelLimit':
        URI_SUFFIX = `${this.URI_SUFFIX.cardChannelLimit}`;
        break;
      case 'cardChannelStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.cardChannelStatus}`;
        break;
      case 'referralStart':
        URI_SUFFIX = `${this.URI_SUFFIX.referralStart}`;
        break;
      case 'dualDocumentAdditionalDocuments':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocument}${id}/additional-documents`;
        break;
      case 'dualDocumentName':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocument}${id}/name`;
        break;
      case 'dualDocumentDob':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocument}${id}/dob`;
        break;
      case 'perfiosNetbanking':
        URI_SUFFIX = `${this.URI_SUFFIX.perfios}${id}/netbanking`;
        break;
      case 'customerSupport':
        URI_SUFFIX = `${this.URI_SUFFIX.customerSupport}${id}`;
        break;
      case 'customerTransactionPaymentMethod':
        URI_SUFFIX = this.URI_SUFFIX.customerTransactionPaymentMethod;
        break;
      case 'offers':
        URI_SUFFIX = this.URI_SUFFIX.offers;
        break;
      case 'onboardingMarketplace':
        URI_SUFFIX = this.URI_SUFFIX.onboardingMarketplace;
        break;
      case 'supplierTransactionDetails':
        URI_SUFFIX = this.URI_SUFFIX.supplierTransactionDetails;
        break;
      case 'customerBlockedTransactions':
        URI_SUFFIX = `${this.URI_SUFFIX.customerBlockedTransactions}${id}`;
        break;
      case 'customerPaymentLink':
        URI_SUFFIX = this.URI_SUFFIX.customerPaymentLink;
        break;
      case 'customerDeliveryUpdate':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/delivery-update/${id2}`;
        break;
      case 'creditloanApprovedAmountDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloanApprovedAmount}${id}/details`;
        break;
      case 'applicationMerchantOnboardingLink':
        URI_SUFFIX = this.URI_SUFFIX.applicationMerchantOnboardingLink;
        break;
      case 'customerPhoneBySession':
        URI_SUFFIX = this.URI_SUFFIX.customerPhoneBySession;
        break;
      case 'customerReferralLink':
        URI_SUFFIX = this.URI_SUFFIX.customerReferralLink;
        break;
      case 'rewards':
        URI_SUFFIX = this.URI_SUFFIX.rewards;
        break;
      case 'rewardsById':
        URI_SUFFIX = `${this.URI_SUFFIX.rewards}/${id}`;
        break;
      case 'homeFlags':
        URI_SUFFIX = this.URI_SUFFIX.homeFlags;
        break;
      case 'digiLockerKarzaOtp':
        URI_SUFFIX = this.URI_SUFFIX.digiLockerKarzaOtp;
        break;
      case 'digiLockerKarzaVerifyOtp':
        URI_SUFFIX = this.URI_SUFFIX.digiLockerKarzaVerifyOtp;
        break;
      case 'v2digiLockerKarzaVerifyOtp':
        URI_SUFFIX = this.URI_SUFFIX.v2digiLockerKarzaVerifyOtp;
        break;
      case 'signdesk':
        URI_SUFFIX = this.URI_SUFFIX.signdesk;
        break;
      case 'customerBankName':
        URI_SUFFIX = this.URI_SUFFIX.customerBankName;
        break;
      case 'customerBranchNameIfsc':
        URI_SUFFIX = this.URI_SUFFIX.customerBranchNameIfsc;
        break;
      case 'generateStatement':
        URI_SUFFIX = this.URI_SUFFIX.generateStatement;
        break;
      case 'initiateTransaction':
          URI_SUFFIX = this.URI_SUFFIX.initiateTransaction;
          break;
      case 'otherBanks':
        URI_SUFFIX = this.URI_SUFFIX.otherBanks;
        break;
      case 'processTransaction':
        URI_SUFFIX = this.URI_SUFFIX.processTransaction;
        break;
      case 'initPaytmSubscription':
          URI_SUFFIX = this.URI_SUFFIX.initPaytmSubscription;
          break;
      case 'registerPaytmMandate':
        URI_SUFFIX = this.URI_SUFFIX.registerPaytmMandate;
        break;
      case 'paymentDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.paymentDetails}/${id}/payments-details`;
        break;
      case 'createConsentOneMoney':
          URI_SUFFIX = `${this.URI_SUFFIX.createConsent}`;
          break;
      // gPay
      case 'averageValue':
        URI_SUFFIX = `${this.URI_SUFFIX.averageValue}`;
        break;
      case 'referralStartForGPay':
        URI_SUFFIX = `${this.URI_SUFFIX.referralStartForGPay}`;
        break;
      case 'applicationMarketplaceMemberships':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/marketplace-memberships`;
        break;
      case 'HomeGPayFetchDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayFetchDetails}`;
        break;
      case 'gPayShortReferral':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayShortReferral}`;
        break;
      case 'applicationApprovals':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/approvals`;
        break;
      case 'gPayMarketplaceDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/marketplace-document`;
        break;
      case 'gPaySuppliers':
        URI_SUFFIX = `${this.URI_SUFFIX.gPaySuppliers}`;
        break;
      case 'transactionSupplier':
        URI_SUFFIX = `${this.URI_SUFFIX.transactionSupplier}${id}`;
        break;
      case 'gPayPaymentDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.paymentDetails}`;
        break;
      case 'gPayProcessPayment':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayProcessPayment}`;
        break;
      case 'gPayResendPaymentOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayResendPaymentOtp}`;
        break;
      case 'gPayVerifyPaymentOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayVerifyPaymentOtp}`;
        break;
      case 'gPayPaymentDetailsTransaction':
        URI_SUFFIX = `${this.URI_SUFFIX.paymentDetails}/${id}`;
        break;
      case 'gPayIsUserBlocked':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayIsUserBlocked}`;
        break;
      case 'gPayPendingSupplier':
        URI_SUFFIX = `${this.URI_SUFFIX.gPayPendingSupplier}`;
        break;
      case 'gPayV2OnboardingLink':
          URI_SUFFIX = `${this.URI_SUFFIX.gPayV2OnboardingLink}`;
          break;
      case 'currentAddress':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/current-address`;
        break;
      case 'aadharAddress':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/aadhar-address`;
        break;
      case 'creditLoanSignMethod':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/loan-sign-method`;
        break;
      case 'creditLoanSanctionDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/sanction-document`;
        break;
      case 'aadharEsign':
        URI_SUFFIX = `${this.URI_SUFFIX.aadhar}/esign/${id}`;
        break;
      case 'aadharEsignSanction':
        URI_SUFFIX = `${this.URI_SUFFIX.aadhar}/esign/${id}/sanction`;
        break;
      case 'v6EmandateBanks':
        URI_SUFFIX = `${this.URI_SUFFIX.v6Emandate}banks/${id}`;
        break;
      case 'panToGst':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/gst`;
        break;
      case 'availableSlots':
        URI_SUFFIX = `${this.URI_SUFFIX.vkyc}/available-slots`;
        break;
      case 'bookSlots':
        URI_SUFFIX = `${this.URI_SUFFIX.vkyc}/${id}/book-slot`;
        break;
      case 'glibUploadBankStatement':
        URI_SUFFIX = `${this.URI_SUFFIX.glib}/${id}/upload-bank-statement`;
        break;
      case 'applicationDiscardDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}/${id}/discard-document`;
        break;
      case 'digiTapMobileUdyamDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.digitap}/${id}/mobile-udyam-details`;
        break;
      case 'digiTapUdyamToBusiness':
        URI_SUFFIX = `${this.URI_SUFFIX.digitap}/${id}/udyam-to-business`;
        break;
      case 'bankStatementStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.bankStatement}/${id}/status`;
        break;
      case 'applicationMandateStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/mandate-status`;
        break;
      case 'applicationNachTemplateUrl':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/nach-template-url`;
        break;
      case 'getLoanDocLanguageList':
        URI_SUFFIX = `${this.URI_SUFFIX.languageList}/list`;
        break;
      case 'loanDocLanguage':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}language`;
        break;
      case 'loanSignStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.onboardingAgreement}/next-step/${id}`;
        break;
      case 'signLoanDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.onboardingAgreement}/click-wrap/sign`;
        break;
      case 'kfsAadharEsign':
        URI_SUFFIX = `${this.URI_SUFFIX.aadhar}/esign/${id}/kfs`;
        break;
      case 'creditLoanKfsDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/kfs-document`;
        break;
      case 'applicationAddress':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/address`;
        break;
      case 'v2CreditLoanBankInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Creditloan}${id}/bank-info`;
        break;
      default:
        URI_SUFFIX = '';
        break;
    }
    return `${this.API_BASE_URI}${URI_SUFFIX}`;
  },
};
